import React from 'react';
import styled from 'styled-components';
import { space, width, height, minHeight, maxHeight, color, overflow } from 'styled-system';
import { Classes, Menu as BlueprintMenu } from '@blueprintjs/core';
import { menuDividerStyles } from './MenuDivider';

const StyledMenu = styled(BlueprintMenu)`
  ${space};
  ${width};
  ${color};
  ${height};
  ${minHeight};
  ${maxHeight};
  ${overflow};

  /* some reasonable resets */
  .${Classes.MENU} {
    min-width: 0;
    background: 'transparent';
  }

  ${menuDividerStyles};
`;

const Menu = (props) => {
  const { minWidth, borderRadius, style = {}, ...rest } = props;

  // effectively takes the key event . .. and passes a focus to the menu item or back to the wrapper to open or close a sub menu.
  // We need this convoluted solution bc blueprint MenuItem actually blocks key events from bubbling up (known issue since 2018).
  const handleKeyDown = (event) => {
    const { key } = event;

    // Use event.target to determine what item is focused
    const focusedEl = event.target;

    if (key === 'Enter' || key === ' ') {
      const popoverTarget = focusedEl.querySelector('[aria-haspopup="true"]');

      const mouseEnter = new MouseEvent('mouseenter', {
        bubbles: true,
        cancelable: true,
        view: window
      });

      if (focusedEl && focusedEl.classList.contains('menu-item-wrapper')) {
        /* 
      If the focused element is a WRAPPER, we can . .. 
      flip the tabindex to 0 and focus it
      */
        if (popoverTarget) {
          popoverTarget.setAttribute('tabindex', '0');

          popoverTarget['aria-expanded'] = 'true';
          popoverTarget['aria-label'] = 'Tab to focus on sub menu items';
          popoverTarget.focus();
          popoverTarget.dispatchEvent(mouseEnter);
          focusedEl.setAttribute('tabindex', '-1');
        } else {
          console.warn('popoverTarget missing but focusedEl is a wrapper');
        }
      } else if (focusedEl && focusedEl.classList.contains('bp4-popover-target')) {
        /* 
      If the focused element is a popover-target, we can . .. 
      flip the tabindex to 0 back to wrapper and focus it - this closes it
      */

        const wrapperEl = focusedEl.closest('.menu-item-wrapper');
        if (wrapperEl) {
          wrapperEl.setAttribute('tabindex', '0');
          wrapperEl.focus();
          focusedEl['aria-expanded'] = 'false';
          wrapperEl['aria-description'] = 'Enter to open submenus';

          wrapperEl.dispatchEvent(mouseEnter);
          focusedEl.setAttribute('tabindex', '-1');
        } else {
          console.warn('Menu: wrapperEl missing but focusedEl is a popover target');
        }
      } else {
        console.warn('Menu: focusedEl wrapper or bp4-popover-target missing');
      }
    }
  };

  return (
    <StyledMenu
      {...rest}
      style={{ minWidth, borderRadius, ...style }}
      role="menu"
      onKeyDown={handleKeyDown}
      autofocus
    />
  );
};

export default Menu;
